import focusPlugin from "@alpinejs/focus";
import Alpine from "alpinejs";
import "@rezstream/ui";
globalThis.Alpine = Alpine;
Alpine.plugin(focusPlugin);
Alpine.start();
